import React from 'react';
import CheckboxGroupContext from './CheckboxGroupContext';

export type CheckboxGroupProps = {
  name?: string;
  value: string[];
  children: React.ReactNode;
  onChange:(
    event: React.ChangeEvent<HTMLInputElement>,
    values: string[]
  ) => void;
};

const CheckboxGroup = ({
  name,
  value,
  onChange,
  children,
}: CheckboxGroupProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(event, [...value, event.target.value]);
    } else {
      onChange(
        event,
        value.filter((item) => item !== event.target.value)
      );
    }
  };

  return (
    <CheckboxGroupContext.Provider value={{ name, value, onChange: handleChange }}>
      {children}
    </CheckboxGroupContext.Provider>
  );
};

export default CheckboxGroup;
